module.exports = __webpack_public_path__ + "1a916675fdc20d55088af68409d70e7e.svg";